/*eslint-disable*/
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { LOCAL_STORAGE } from '../../utils/constants';

function IntegratedReferenceNumber(props) {
  const [loading, setIsLoading] = useState(false);

  const onReload = async (customerInvoiceNo) => {
    if(props?.data?.reloadIntegratedRefNo){
      window.location.reload()
      return
    }
    setIsLoading(true);
    const congData = {
      customer_no: LOCAL_STORAGE.customerNo,
      user_id: LOCAL_STORAGE.userId,
      reference_number: customerInvoiceNo
    };

    await Axios.post(`${process.env.REACT_APP_BASE_URL}/sales/sales-invoices/approvedInvoiceIntegrateInOracle`,
      congData,
      { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
      .then((response) => {
        if (response.status === 200) {
          cogoToast.success('Reloaded sucessfully').then(() => {
            window.location.reload();
          })
        }
      })
    setIsLoading(false);
  };

  return (
    <>
      {props?.data?.integratedReferenceNumber || ''}
      {props.data.integratedReferenceNumber == 'Error' ?
        <>
          <Button basic className="w3-tiny ml-2" style={{ color: "#006837" }} circular type="button" icon>
            <Icon name="info" size='small' style={{ color: "#006837" }} title={props.data.integratedReferenceNumberErrorContent} />
          </Button>

          <Button disabled={loading} basic className="w3-tiny ml-2" circular type="button" icon onClick={() => { onReload(props?.data?.customerInvoiceNo) }}>
            <Icon name="refresh" size='small' color="blue" title={'Reload'} />
          </Button>
        </>
        :
        null
      }
    </>
  )
}

export default IntegratedReferenceNumber
